<style>
  .nav-menu li a {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    padding: 8px 12px;
  }

  .nav-menu li a i {
    font-size: 1.1rem;
  }

  .nav-menu li a:hover {
    color: #ffdd55;
  }

  .announcement-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .announcement-content .left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .announcement-content .right {
    color: #ffc107;
    /* yellow */
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
  }

  /* =========================
   RESET
========================= */
  * {
    box-sizing: border-box;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  /* =========================
   SIDEBAR BASE
========================= */
  .sidebar {
    /* width: 280px; */
    height: 100vh;
    /* background-color: #0f4c81; */

    /* background: #0a3a5c; */
    background: linear-gradient(180deg, #0a2540 0%, #0f4c81 100%);
    color: #cfd8e3;
    display: flex;
    flex-direction: column;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  }

  /* =========================
   HEADER / LOGO
========================= */
  .sidebar-header {
    padding: 20px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .logo-icon {
    width: 40px;
    height: 40px;
  }

  .logo-image {
    width: 100%;
    height: auto;
  }

  .logo-text {
    display: flex;
    flex-direction: column;
  }

  .logo-title {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
  }

  .logo-sub {
    font-size: 13px;
    font-weight: 600;
    color: #9ca3af;
  }

  /* =========================
   NAV CONTAINER
========================= */
  .sidebar-nav {
    flex: 1;
    overflow-y: auto;
    padding-top: 10px;
  }

  /* =========================
   NAV ITEMS
========================= */
  .nav-list {
    list-style: none;
  }

  .nav-item {
    width: 100%;
  }

  /* =========================
   LINKS
========================= */
  .nav-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 18px;
    color: #cfd8e3;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;
  }

  .nav-link:hover {
    background: #2b3a4e;
    color: #ffffff;
  }

  /* Active route */
  .active-link {
    background: #314764;
    color: #ffffff;
    border-left: 4px solid #f7b500;
  }

  /* Icons */
  .nav-link i {
    font-size: 16px;
    min-width: 20px;
    text-align: center;
  }

  /* =========================
   PARENT WITH CHILDREN
========================= */
  .has-children {
    width: 100%;
  }

  /* Parent clickable row */
  .parent-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 18px;
    cursor: pointer;
    color: #cfd8e3;
    transition: background 0.2s ease;
  }

  .parent-link:hover {
    background: #2b3a4e;
  }

  /* Chevron */
  .toggle-icon {
    margin-left: auto;
    font-size: 14px;
    transition: transform 0.3s ease;
  }

  /* Rotate when open */
  .parent-link.expanded .toggle-icon {
    transform: rotate(180deg);
  }

  /* =========================
   SUBMENU
========================= */
  .submenu {
    background: #233145;
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.3s ease;
  }

  /* Show submenu */
  .submenu.open {
    max-height: 400px;
  }

  /* Submenu links */
  .submenu .nav-link {
    padding: 10px 18px 10px 48px;
    font-size: 14px;
  }

  /* Hover */
  .submenu .nav-link:hover {
    background: #2f415c;
  }

  /* Active submenu */
  .submenu .active-link {
    background: #3a5476;
    border-left: 4px solid #f7b500;
  }

  .user-avatar {
    font-size: 30px;
    color: #fbbf24;
    /* yellow color */
    display: block;
  }

  /* =========================
   FOOTER / USER
========================= */
  .sidebar-footer {
    padding: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .sidebar-user {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .user-avatar-container {
    width: 40px;
    height: 40px;
  }

  .user-avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .sidebar-user-info {
    display: flex;
    flex-direction: column;
  }

  .sidebar-user-info .name {
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
  }

  .sidebar-user-info .role {
    font-size: 12px;
    color: #9ca3af;
  }
</style>

<aside class="sidebar" [ngClass]="{ collapsed: collapsed }" *ngIf="isAuthenticated">
  <!-- Sidebar Header -->
  <div class="sidebar-header">
    <div class="logo" [routerLink]="roleId == 1 ? '/admin/AdminDash' : '/dashboard'">
      <div class="logo-icon">
        <img src="../../assets/images/logos/hplogo.png" alt="HP Logo" class="logo-image" />
      </div>
      <div class="logo-text" *ngIf="!collapsed">
        <span class="logo-title">Department of Cooperation</span>
        <span class="logo-sub">Himachal Pradesh</span>
      </div>
    </div>
  </div>

  <!-- Navigation -->
  <nav class="sidebar-nav">
    <ul class="nav-list">
      <ng-container *ngFor="let item of navItems">
        <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: item }">
        </ng-container>
      </ng-container>
    </ul>
  </nav>

  <!-- Recursive Template -->
  <ng-template #recursiveMenu let-item>
    <li class="nav-item">

      <a *ngIf="!item.children || item.children.length === 0" [routerLink]="item.route" class="nav-link"
        routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">

        <i class="bi" [ngClass]="item.icon" (click)="toggleSidebar.emit()" [ngbTooltip]="item.label"  placement="right"
            container="body"></i>
        <span class="nav-label" *ngIf="!collapsed">{{ item.label }}</span>
      </a>

      <!-- <div *ngIf="item.children?.length" class="has-children">

        <div class="parent-link" [ngClass]="{ expanded: item.expanded }" (click)="item.expanded = !item.expanded">

          <i class="bi" [ngClass]="item.icon"></i>
          <span class="nav-label" *ngIf="!collapsed">{{ item.label }}</span>
          <i class="bi bi-chevron-down toggle-icon" *ngIf="!collapsed"></i>
        </div>

        <ul class="submenu" [class.open]="item.expanded && !collapsed">
          <ng-container *ngFor="let child of item.children">
            <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: child }">
            </ng-container>
          </ng-container>
        </ul>


      </div> -->
      <div *ngIf="item.children?.length" class="has-children">

        <div class="parent-link" [ngClass]="{ expanded: item.expanded }" (click)="item.expanded = !item.expanded">

          <i class="bi" [ngClass]="item.icon" (click)="toggleSidebar.emit()" [ngbTooltip]="item.label"  placement="right"
            container="body"></i>
          <span class="nav-label" *ngIf="!collapsed">{{ item.label }}</span>
          <i class="bi bi-chevron-down toggle-icon" *ngIf="!collapsed"></i>

        </div>

        <ul class="submenu" [class.open]="item.expanded && !collapsed">
          <ng-container *ngFor="let child of item.children">
            <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: child }">
            </ng-container>
          </ng-container>
        </ul>

      </div>
    </li>
  </ng-template>


  <!-- Footer -->
  <!-- <div class="sidebar-footer" *ngIf="!collapsed">
    <div class="sidebar-user">
      <div class="user-avatar-container">
        <i class="bi bi-person-circle user-avatar"></i>
      </div>
      <div class="sidebar-user-info">
        <span class="name">{{ userName }}</span>
        <span class="role">{{ displayRoleName }}</span>
      </div>
    </div>
  </div> -->
</aside>